import 'css-chunk:src/feature/check/CheckRouter.module.scss';export default {
  "menu": "CheckRouter_menu",
  "menu-invisible": "CheckRouter_menu-invisible",
  "full-page-modal": "CheckRouter_full-page-modal",
  "full-page-modal-show": "CheckRouter_full-page-modal-show"
};